<template>
  <v-card>
    <v-tabs v-model="activeTab">
      <v-tab>Local</v-tab>
      <v-tab>Public</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <!-- Local Tab -->
      <v-tab-item>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-checkbox
                v-model="editItem.sendingInfoToOkTaxRolls"
                class="input-text-size"
                label="Sending Info to OktaxRolls"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="pt-0 pb-0">
              <label class="text-decoration-underline input-text-size font-weight-bold">
                Email Recipients
              </label>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-text-field class="input-text-size pa-0" v-model="editItem.emailAddress1"
                label="(1) Email Address" />
            </v-col>
            <v-col cols="2">
              <v-text-field class="input-text-size pa-0" v-model="editItem.emailAddress2"
                label="(2) Email Address" />
            </v-col>
            <v-col cols="2">
              <v-text-field class="input-text-size pa-0" v-model="editItem.emailAddress3"
                label="(3) Email Address" />
            </v-col>
            <v-col cols="2">
              <v-text-field class="input-text-size pa-0" v-model="editItem.emailAddress4"
                label="(4) Email Address" />
            </v-col>
            <v-col cols="2">
              <v-text-field class="input-text-size pa-0" v-model="editItem.emailAddress5"
                label="(5) Email Address" />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="primary" @click="updateLocal">Save</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-tab-item>

      <!-- Public Tab -->
      <v-tab-item>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <label class="input-text-size font-weight-bold">Payment Types to Accept</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto" class="pt-0 pb-0">
              <v-checkbox
                v-model="paymentConfigItem.allowFullPayment"
                class="input-text-size"
                label="Full"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="auto" class="pt-0 pb-0">
              <v-checkbox
                v-model="paymentConfigItem.allowHalfPayment"
                class="input-text-size"
                label="Half"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-0">
              <v-checkbox
                v-model="paymentConfigItem.pmtDelinq"
                class="input-text-size"
                label="Force Payment of all Delinquents"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-0">
              <v-checkbox
                v-model="paymentConfigItem.allowCcpmt"
                class="input-text-size"
                label="Allow Payments"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-0">
              <v-checkbox
                v-model="paymentConfigItem.disablepmtOption"
                class="input-text-size"
                label="Disable Payment Option for Year(s) selected"
              ></v-checkbox>
            </v-col>
            <v-col v-if="paymentConfigItem.disablepmtOption" cols="2" class="pt-0 pb-0">
              <v-text-field
                v-model.number="paymentConfigItem.disablepmtFromyear"
                class="input-text-size"
                label="From Year"
                type="number"
              />
            </v-col>
            <v-col v-if="paymentConfigItem.disablepmtOption" cols="2" class="pt-0 pb-0">
              <v-text-field
                v-model.number="paymentConfigItem.disablepmtToyear"
                class="input-text-size"
                label="To Year"
                type="number"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-0">
              <v-checkbox
                v-model="paymentConfigItem.disableMtgPayments"
                class="input-text-size"
                label="Disable Payments for Mtg Codes"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pt-0 pb-0">
              <v-autocomplete
                v-model="selectedMtgCodes"
                :items="mtgCodeOptions"
                :loading="mtgCodesLoading"
                class="input-text-size"
                label="Mortgage Code Exceptions"
                :hint="mtgCodeExceptionsHint"
                persistent-hint
                multiple
                chips
                small-chips
                clearable
              >
                <template v-slot:selection="{ item, attrs, parent }">
                  <v-chip
                    v-bind="attrs"
                    small
                    close
                    :color="item.unknown ? 'error' : undefined"
                    :outlined="item.unknown"
                    @click:close="parent.selectItem(item)"
                  >{{ item.value }}</v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              @click="updatePublic"
            >Save</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { cloneItem } from '../../util/shared/vue-global';

export default {
  data: () => ({
    activeTab: 0,
    originalTaxWebSetting: null,
    mtgCodes: [],
    mtgCodesLoading: false,
  }),
  computed: {
    ...mapState({
      taxWebSettingItem: (state) => state.SystemConfig.taxWebSettingItem || {},
      taxWebPaymentConfig: (state) => state.tax.ccPayments.taxWebPaymentConfig || {},
    }),
    editItem() {
      return this.taxWebSettingItem;
    },
    paymentConfigItem() {
      return this.taxWebPaymentConfig;
    },
    // mtgCodeList is stored on OkTaxRolls as a comma-separated string - the selector edits it as an array
    selectedMtgCodes: {
      get() {
        return (this.paymentConfigItem.mtgCodeList || '').split(',').map((c) => c.trim()).filter(Boolean);
      },
      set(codes) {
        this.$set(this.paymentConfigItem, 'mtgCodeList', (codes || []).join(','));
      },
    },
    // Codes saved from the OkTaxRolls admin portal may not exist here (e.g. a 4 digit code);
    // keep them selectable so they show up as chips the user can see and remove
    unknownMtgCodes() {
      if (this.mtgCodesLoading) return [];
      const known = new Set(this.mtgCodes.map((c) => c.mtgCode));
      return this.selectedMtgCodes.filter((code) => !known.has(code));
    },
    mtgCodeOptions() {
      const options = this.mtgCodes.map((c) => ({
        text: c.mtgCoName ? `${c.mtgCode} - ${c.mtgCoName}` : c.mtgCode,
        value: c.mtgCode,
      }));
      const unknown = this.unknownMtgCodes.map((code) => ({
        text: `${code} (not a mortgage code in this system)`,
        value: code,
        unknown: true,
      }));
      return [...unknown, ...options];
    },
    mtgCodeExceptionsHint() {
      if (this.unknownMtgCodes.length === 0) return 'Select the mortgage codes to exclude.';
      return `Not a mortgage code in this system, consider removing: ${this.unknownMtgCodes.join(', ')}`;
    },
  },
  async created() {
    await Promise.all([
      this.loadConfig({ requiredScope: 'taxWebConfig' }),
      this.loadTaxWebPaymentConfig(),
      this.loadMtgCodes(),
    ]);
    this.originalTaxWebSetting = cloneItem(this.buildTaxWebConfigItem());
  },
  methods: {
    ...mapActions('SystemConfig', ['updateConfig', 'loadConfig']),
    ...mapActions('tax/ccPayments', [
      'updateGlobalTaxWebsiteSystemConfig',
      'loadTaxWebPaymentConfig',
      'upsertTaxWebPaymentConfig',
    ]),
    ...mapActions('shared/taxMortgageCodesShared', ['loadTaxMortgageCodesSharedRecords']),
    async loadMtgCodes() {
      this.mtgCodesLoading = true;
      try {
        // limit 0 = every code, the exception list can hold any of them
        this.mtgCodes = await this.loadTaxMortgageCodesSharedRecords({
          criteria: { limit: 0, sortBy: [{ column: 'mtgCode', direction: 'asc' }] },
          baseCrudKey: 'taxWebSettingMtgCodes',
        }) || [];
      } finally {
        this.mtgCodesLoading = false;
      }
    },
    buildTaxWebConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the tax web setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        sendingInfoToOkTaxRolls: settingItem.sendingInfoToOkTaxRolls,
        emailAddress1: settingItem.emailAddress1,
        emailAddress2: settingItem.emailAddress2,
        emailAddress3: settingItem.emailAddress3,
        emailAddress4: settingItem.emailAddress4,
        emailAddress5: settingItem.emailAddress5,
      };
    },
    buildPaymentConfigItem() {
      const cfg = this.paymentConfigItem;
      return {
        allowFullPayment: cfg.allowFullPayment,
        allowHalfPayment: cfg.allowHalfPayment,
        allowCcpmt: cfg.allowCcpmt,
        pmtDelinq: cfg.pmtDelinq,
        disablepmtOption: cfg.disablepmtOption,
        disablepmtFromyear: cfg.disablepmtFromyear || 0,
        disablepmtToyear: cfg.disablepmtToyear || 0,
        disableMtgPayments: cfg.disableMtgPayments,
        mtgCodeList: cfg.mtgCodeList || '',
      };
    },
    async updateLocal() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'taxWebConfig',
          item: this.buildTaxWebConfigItem(),
          previousItem: this.originalTaxWebSetting,
          isLogAudit: true,
        };
        const ok = await this.updateConfig(payload);
        if (ok) {
          this.originalTaxWebSetting = cloneItem(this.buildTaxWebConfigItem());
        }
        this.updateGlobalTaxWebsiteSystemConfig();
      }
    },
    async updatePublic() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        await this.upsertTaxWebPaymentConfig({ upsert: this.buildPaymentConfigItem() });
      }
    },
  },
};
</script>
